(function () {
  const drawer = document.querySelector("[data-cart-drawer]");
  const backdrop = document.querySelector("[data-cart-drawer-backdrop]");

  if (!drawer || !backdrop) return;

  const loadingEl = drawer.querySelector("[data-cart-drawer-loading]");
  const contentEl = drawer.querySelector("[data-cart-drawer-content]");
  const emptyEl = drawer.querySelector("[data-cart-drawer-empty]");
  const statusEl = drawer.querySelector("[data-cart-drawer-status]");
  const itemsEl = drawer.querySelector("[data-cart-drawer-items]");
  const footerEl = drawer.querySelector("[data-cart-drawer-footer]");
  const recommendationsEl = drawer.querySelector("[data-cart-drawer-recommendations]");
  const recommendationsGridEl = drawer.querySelector("[data-cart-drawer-recommendations-grid]");
  const totalEl = drawer.querySelector("[data-cart-drawer-total]");
  const compareTotalEl = drawer.querySelector(
    "[data-cart-drawer-compare-total]",
  );
  const subtotalEl = drawer.querySelector("[data-cart-drawer-subtotal]");
  const savingsBlockEl = drawer.querySelector(
    "[data-cart-drawer-savings-block]",
  );
  const discountLinesEl = drawer.querySelector(
    "[data-cart-drawer-discount-lines]",
  );
  const totalSavingsEl = drawer.querySelector(
    "[data-cart-drawer-total-savings]",
  );
  const discountInput = drawer.querySelector(
    "[data-cart-drawer-discount-input]",
  );
  const closeBtns = drawer.querySelectorAll("[data-cart-drawer-close]");
  const iconCloseTpl = drawer.querySelector("[data-cart-drawer-icon-close]");
  const iconDiscountTpl = drawer.querySelector(
    "[data-cart-drawer-icon-discount]",
  );
  const iconRemoveDiscountTpl = drawer.querySelector(
    "[data-cart-drawer-icon-remove-discount]",
  );
  const iconHeartTpl = drawer.querySelector("[data-cart-drawer-icon-heart]");
  const iconFireTpl = drawer.querySelector("[data-cart-drawer-icon-fire]");
  const iconCircleXTpl = drawer.querySelector(
    "[data-cart-drawer-icon-circle-x]",
  );
  const summaryToggleBtn = drawer.querySelector(
    "[data-cart-drawer-summary-toggle]",
  );
  const summaryDetailsEl = drawer.querySelector(
    "[data-cart-drawer-summary-details]",
  );
  const summaryChevronEl = drawer.querySelector(
    "[data-cart-drawer-summary-chevron]",
  );
  const toggleSavingsEl = drawer.querySelector(
    "[data-cart-drawer-toggle-savings]",
  );

  const requiredEls = [
    loadingEl,
    contentEl,
    emptyEl,
    itemsEl,
    footerEl,
    totalEl,
    iconCloseTpl,
    iconDiscountTpl,
  ];
  if (requiredEls.some((el) => !el)) return;

  const moneyFormat =
    drawer.getAttribute("data-money-format") || "\u20AC{{amount}}";
  const cartUrl = drawer.getAttribute("data-cart-url") || "/cart";

  const errorEl = drawer.querySelector("[data-cart-drawer-discount-error]");

  const emptyCartCollection =
    drawer.getAttribute("data-empty-cart-collection") || "";

  const translations = Object.assign(
    {
      decreaseQuantity: "Decrease quantity",
      increaseQuantity: "Increase quantity",
      quantity: "Quantity",
      removeTitleTemplate: "Remove __TITLE__",
      youSaveTemplate: "You save __AMOUNT__",
      removeDiscount: "Remove discount code",
      discountInvalid: "Invalid discount code",
      cartError:
        "An error occurred while updating your cart. Please try again.",
      recommendationsTitle: "You might also like",
      addToWishlist: "Add to wishlist",
      soldOut: "Sold out",
      badgeHighDemand: "High demand",
      moreVariantsTemplate: "+__COUNT__ variants",
      flavoursCountTemplate: "__COUNT__ flavours",
    },
    {
      decreaseQuantity: drawer.getAttribute("data-t-decrease-quantity"),
      increaseQuantity: drawer.getAttribute("data-t-increase-quantity"),
      quantity: drawer.getAttribute("data-t-quantity"),
      removeTitleTemplate: drawer.getAttribute("data-t-remove-title"),
      youSaveTemplate: drawer.getAttribute("data-t-you-save"),
      removeDiscount: drawer.getAttribute("data-t-remove-discount"),
      discountInvalid: drawer.getAttribute("data-t-discount-invalid"),
      cartError: drawer.getAttribute("data-t-cart-error"),
      recommendationsTitle: drawer.getAttribute("data-t-recommendations-title"),
      addToWishlist: drawer.getAttribute("data-t-add-to-wishlist"),
      soldOut: drawer.getAttribute("data-t-sold-out"),
      badgeHighDemand: drawer.getAttribute("data-t-badge-high-demand"),
      moreVariantsTemplate: drawer.getAttribute("data-t-more-variants-template"),
      flavoursCountTemplate: drawer.getAttribute(
        "data-t-flavours-count-template",
      ),
    },
  );

  /* Filter out null/undefined from data-attributes so defaults survive */
  Object.keys(translations).forEach((k) => {
    if (translations[k] == null) delete translations[k];
  });

  const heartSvg = iconHeartTpl ? iconHeartTpl.innerHTML.trim() : "";
  const fireSvg = iconFireTpl ? iconFireTpl.innerHTML.trim() : "";
  const circleXSvg = iconCircleXTpl ? iconCircleXTpl.innerHTML.trim() : "";

  let isOpen = false;
  let isRendering = false;
  let busyCount = 0;

  /* ── Utilities ───────────────────────────────────────────── */

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const amountWithComma = amount
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const amountNoDecimals = Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        amountNoDecimals,
      )
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
  }

  function getImageUrl(url, width) {
    if (!url) return "";
    const normalized = url.startsWith("//") ? `https:${url}` : url;
    const separator = normalized.includes("?") ? "&" : "?";
    return `${normalized}${separator}width=${width}`;
  }

  function escapeHtml(text) {
    const div = document.createElement("div");
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
  }

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  function setDrawerBusy(busy) {
    if (!statusEl) return;

    if (busy) {
      busyCount += 1;
    } else {
      busyCount = Math.max(0, busyCount - 1);
    }

    const isBusy = busyCount > 0;
    drawer.setAttribute("aria-busy", String(isBusy));
    statusEl.classList.toggle("hidden", !isBusy);
    statusEl.setAttribute("aria-hidden", String(!isBusy));
  }

  /* ── Drawer open / close ─────────────────────────────────── */

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;

    drawer.classList.remove("translate-y-full", "lg:translate-x-full");
    drawer.classList.add("translate-y-0", "lg:translate-x-0");
    backdrop.classList.remove("opacity-0", "pointer-events-none");
    backdrop.classList.add("opacity-100", "pointer-events-auto");

    document.body.classList.add("overflow-hidden");
    drawer.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(drawer);
      if (focusable.length > 0) {
        focusable[0].focus();
      }
    });

    document.addEventListener("keydown", handleKeydown);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    drawer.classList.remove("translate-y-0", "lg:translate-x-0");
    drawer.classList.add("translate-y-full", "lg:translate-x-full");
    backdrop.classList.remove("opacity-100", "pointer-events-auto");
    backdrop.classList.add("opacity-0", "pointer-events-none");

    document.body.classList.remove("overflow-hidden");
    drawer.setAttribute("aria-hidden", "true");

    document.removeEventListener("keydown", handleKeydown);
  }

  function handleKeydown(e) {
    if (e.key === "Escape") {
      closeDrawer();
      return;
    }

    if (e.key === "Tab") {
      const focusable = getFocusableElements(drawer);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ── Cart API ──────────────────────────────────────────────── */

  const parseQty = (value) => parseInt(value, 10) || 0;

  async function fetchCart() {
    const res = await fetch(`${cartUrl}.js`, {
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(res.statusText);
    return res.json();
  }

  async function changeCartLine(id, quantity) {
    return window.theme.cartMutate(async () => {
      const res = await fetch(`${window.routes.cart_change_url}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity }),
      });
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
    });
  }

  async function clearCartDiscountCodes() {
    return window.theme.cartMutate(async () => {
      const res = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: "" }),
      });
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
    });
  }

  /* ── Render line items ─────────────────────────────────────── */

  function buildLineItemHtml(item) {
    const title = escapeHtml(item.product_title);
    const { url } = item;
    const removeLabel = translations.removeTitleTemplate.replace(
      "__TITLE__",
      title,
    );

    const imageHtml = item.image
      ? `<img src="${getImageUrl(item.image, 240)}" alt="${title}" loading="lazy" class="w-full h-full object-contain">`
      : "";

    const variantHtml = item.variant_title
      ? `<span class="caption text-subdued">${escapeHtml(item.variant_title)}</span>`
      : "";

    const lineSaving = item.original_line_price - item.final_line_price;
    const hasDiscountCodes = item.line_level_discount_allocations.length > 0;

    const priceColorClass = lineSaving > 0 ? "text-discount" : "text-primary";
    const priceParts = [
      `<span class="text-sm ${priceColorClass}" data-drawer-line-price>${formatMoney(item.final_line_price)}</span>`,
    ];
    if (lineSaving > 0) {
      priceParts.push(
        `<s class="caption text-subdued" data-drawer-line-compare-price>${formatMoney(item.original_line_price)}</s>`,
      );
      if (!hasDiscountCodes) {
        const savingLabel = translations.youSaveTemplate.replace(
          "__AMOUNT__",
          formatMoney(lineSaving),
        );
        priceParts.push(
          `<span class="caption font-bold text-[var(--color-success)]" data-drawer-line-savings>${escapeHtml(savingLabel)}</span>`,
        );
      }
    }
    const priceHtml = priceParts.join("");

    const discountHtml = hasDiscountCodes
      ? item.line_level_discount_allocations
          .filter(
            (d) => d.discount_application?.title != null && d.amount != null,
          )
          .map(
            (d) => `
          <div class="flex items-center gap-1.5" data-drawer-line-discount>
            <span class="shrink-0 leading-[0]" data-drawer-discount-icon></span>
            <span class="caption font-semibold text-primary">${escapeHtml(d.discount_application.title)}</span>
            <span class="caption text-[var(--color-success)]">(&minus;${formatMoney(d.amount)})</span>
          </div>`,
          )
          .join("")
      : "";

    return `
      <div class="relative flex gap-3 items-start lg:gap-4 py-4 first:pt-0 last:pb-0" data-cart-drawer-line-item data-line-item-key="${item.key}">
        <a href="${url}" class="block shrink-0 size-20 rounded-sm overflow-hidden cursor-pointer">
          ${imageHtml}
        </a>
        <div class="flex-1 min-w-0 flex flex-col gap-3">
          <div class="flex flex-col gap-1.5 pr-6">
            <a href="${url}" class="text-sm font-bold text-primary line-clamp-2 cursor-pointer">${title}</a>
            ${variantHtml}
            <div class="flex flex-wrap items-baseline gap-2">${priceHtml}</div>
            ${discountHtml}
          </div>
          <div class="flex items-center gap-3">
            <div class="bg-white border border-gradient-light rounded-round flex items-center shrink-0">
              <button
                type="button"
                class="flex items-center justify-center size-8 lg:size-10 text-xs text-subdued font-semibold cursor-pointer"
                aria-label="${escapeHtml(translations.decreaseQuantity)}"
                data-drawer-qty-minus
              >&minus;</button>
              <input
                type="number"
                value="${item.quantity}"
                min="0"
                class="w-5 lg:w-6 text-center text-xs font-bold text-primary bg-transparent border-none outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield]"
                aria-label="${escapeHtml(translations.quantity)}"
                data-drawer-qty-input
              >
              <button
                type="button"
                class="flex items-center justify-center size-8 lg:size-10 text-xs text-primary font-semibold cursor-pointer"
                aria-label="${escapeHtml(translations.increaseQuantity)}"
                data-drawer-qty-plus
              >+</button>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="absolute top-0 right-0 flex items-center justify-center size-6 cursor-pointer"
          aria-label="${removeLabel}"
          data-drawer-remove-item
        ></button>
      </div>`;
  }

  function renderCart(cart) {
    loadingEl.classList.add("hidden");

    if (cart.item_count === 0) {
      showEmptyState();
      return;
    }

    emptyEl.classList.add("hidden");
    emptyEl.classList.remove("flex");
    contentEl.classList.remove("hidden");

    itemsEl.innerHTML = cart.items.map(buildLineItemHtml).join("");

    /* Clone icons into dynamic elements */
    itemsEl.querySelectorAll("[data-drawer-remove-item]").forEach((btn) => {
      btn.appendChild(iconCloseTpl.content.cloneNode(true));
    });
    itemsEl.querySelectorAll("[data-drawer-discount-icon]").forEach((el) => {
      el.appendChild(iconDiscountTpl.content.cloneNode(true));
    });

    updateTotal(cart);
    renderFooterSavings(cart);
  }

  function updateTotal(cart) {
    const hasSavings = cart.original_total_price > cart.total_price;

    totalEl.textContent = formatMoney(cart.total_price);
    totalEl.classList.toggle("text-discount", hasSavings);
    totalEl.classList.toggle("text-primary", !hasSavings);

    if (compareTotalEl) {
      if (hasSavings) {
        compareTotalEl.textContent = formatMoney(cart.original_total_price);
        compareTotalEl.classList.remove("hidden");
      } else {
        compareTotalEl.classList.add("hidden");
      }
    }
  }

  function getAllDiscountApplications(cart) {
    const seen = new Set();
    const discounts = [];

    (cart.cart_level_discount_applications || []).forEach((d) => {
      if (d.title == null || d.total_allocated_amount == null) return;
      seen.add(d.title);
      discounts.push(d);
    });

    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((alloc) => {
        const app = alloc.discount_application;
        if (!app || app.title == null || app.total_allocated_amount == null)
          return;
        if (seen.has(app.title)) return;
        seen.add(app.title);
        discounts.push(app);
      });
    });

    return discounts;
  }

  function updateSummaryToggle(hasSavings) {
    if (!summaryToggleBtn) return;

    /* The toggle is always enabled — the discount input lives inside the
       collapsible, so users must be able to open it regardless of savings. */
    summaryToggleBtn.disabled = false;
    summaryToggleBtn.classList.add("cursor-pointer");
    summaryToggleBtn.classList.remove("cursor-default");

    if (summaryChevronEl) {
      summaryChevronEl.classList.remove("hidden");
    }

    /* When savings disappear, collapse the details — but only if the user
       hasn't explicitly opened the section (e.g. to enter a discount code). */
    const isExpanded =
      summaryToggleBtn.getAttribute("aria-expanded") === "true";
    if (!hasSavings && !isExpanded && summaryDetailsEl) {
      summaryDetailsEl.classList.add("hidden");
      summaryDetailsEl.classList.remove("flex");
      if (summaryChevronEl) {
        summaryChevronEl.classList.remove("-rotate-180");
      }
    }
  }

  function renderFooterSavings(cart) {
    if (!savingsBlockEl || !subtotalEl || !discountLinesEl || !totalSavingsEl)
      return;

    const totalSavings = cart.original_total_price - cart.total_price;

    if (totalSavings <= 0) {
      updateSummaryToggle(false);
      savingsBlockEl.classList.add("hidden");
      savingsBlockEl.classList.remove("flex");
      if (toggleSavingsEl) toggleSavingsEl.classList.add("hidden");
      return;
    }

    updateSummaryToggle(true);

    if (toggleSavingsEl) {
      toggleSavingsEl.innerHTML = `(&minus;${formatMoney(totalSavings)})`;
      toggleSavingsEl.classList.remove("hidden");
    }

    subtotalEl.textContent = formatMoney(cart.original_total_price);

    const discountHtml = getAllDiscountApplications(cart)
      .map((d) => {
        const removeBtn =
          d.type === "discount_code"
            ? `<button
                type="button"
                class="flex items-center justify-center size-5 shrink-0 text-subdued cursor-pointer"
                title="${escapeHtml(translations.removeDiscount)}"
                aria-label="${escapeHtml(translations.removeDiscount)}"
                data-drawer-discount-remove="${escapeHtml(d.title)}"
              ></button>`
            : "";
        return `
          <div class="flex justify-between items-center w-full">
            <span class="text-sm text-primary flex items-center gap-1">
              <span class="shrink-0 leading-[0]" data-drawer-discount-icon></span>
              <span>${escapeHtml(d.title)}</span>
              ${removeBtn}
            </span>
            <span class="text-sm text-[var(--color-success)]">&minus; ${formatMoney(d.total_allocated_amount)}</span>
          </div>`;
      })
      .join("");

    discountLinesEl.innerHTML = discountHtml;

    /* Clone discount icons into footer */
    discountLinesEl
      .querySelectorAll("[data-drawer-discount-icon]")
      .forEach((el) => {
        el.appendChild(iconDiscountTpl.content.cloneNode(true));
      });

    /* Clone remove-discount icons */
    if (iconRemoveDiscountTpl) {
      discountLinesEl
        .querySelectorAll("[data-drawer-discount-remove]")
        .forEach((btn) => {
          btn.appendChild(iconRemoveDiscountTpl.content.cloneNode(true));
        });
    }

    totalSavingsEl.innerHTML = `&minus; ${formatMoney(totalSavings)}`;

    savingsBlockEl.classList.remove("hidden");
    savingsBlockEl.classList.add("flex");
  }

  async function fetchRecommendations() {
    if (!emptyCartCollection) return [];
    try {
      const res = await fetch(
        `/collections/${emptyCartCollection}/products.json?limit=4`,
        { headers: { Accept: "application/json" } },
      );
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    } catch {
      return [];
    }
  }

  function buildBadgeHtml(badgeType) {
    if (badgeType === "sold-out") {
      return `
        <div class="absolute top-2 left-2 lg:top-[18px] lg:left-[18px] z-20 flex items-center gap-1 px-2 py-1 rounded-full" style="background: #6b7280">
          <span class="text-white">${circleXSvg}</span>
          <span class="caption text-white">${escapeHtml(translations.soldOut)}</span>
        </div>`;
    }
    if (badgeType === "hohe-nachfrage") {
      return `
        <div class="absolute top-2 left-2 lg:top-[18px] lg:left-[18px] z-20 bg-gradient-dark flex items-center gap-1 px-2 py-1 rounded-full">
          ${fireSvg}
          <span class="caption text-white">${escapeHtml(translations.badgeHighDemand)}</span>
        </div>`;
    }
    return "";
  }

  function buildRecommendationCardHtml(product) {
    const title = escapeHtml(product.title);
    const handle = escapeHtml(product.handle);
    const url = `/products/${handle}`;
    const variants = product.variants || [];
    const firstVariant = variants[0] || {};

    const priceCents = firstVariant.price
      ? Math.round(parseFloat(firstVariant.price) * 100)
      : 0;
    const compareCents = firstVariant.compare_at_price
      ? Math.round(parseFloat(firstVariant.compare_at_price) * 100)
      : 0;
    const isOnSale = compareCents > priceCents && priceCents > 0;

    const isAvailable =
      variants.length === 0 || variants.some((v) => v.available !== false);

    const tags = (product.tags || []).map((t) => (t || "").toLowerCase().trim());
    const hasHoheNachfrage =
      tags.includes("hohe-nachfrage") || tags.includes("hohe nachfrage");
    const hasClothingTag = tags.includes("kleidung");

    let badgeType = "";
    if (!isAvailable) {
      badgeType = "sold-out";
    } else if (hasHoheNachfrage) {
      badgeType = "hohe-nachfrage";
    }
    const badgeHtml = buildBadgeHtml(badgeType);

    const fi = product.featured_image;
    let imageSrc = "";
    if (fi) {
      imageSrc = typeof fi === "string" ? fi : fi.src || "";
    }
    if (!imageSrc && product.images && product.images.length > 0) {
      const img = product.images[0];
      imageSrc = typeof img === "string" ? img : img.src || "";
    }
    const imageHtml = imageSrc
      ? `<img src="${getImageUrl(imageSrc, 1200)}" alt="${title}" loading="lazy" class="w-full h-[80%] object-contain">`
      : "";

    const wishlistHtml = heartSvg
      ? `<button type="button" class="st-wishlist-button absolute top-2 right-2 z-10 text-primary hover:text-discount transition-colors" aria-label="${escapeHtml(translations.addToWishlist)}" data-type="product-card" data-handle="${handle}">${heartSvg}</button>`
      : "";

    const skus = variants
      .map((v) => v.sku)
      .filter(Boolean)
      .join(",");
    const etrustedHtml = skus
      ? `
        <div class="origin-top-left scale-[0.70] lg:scale-[0.85] h-[20px] lg:h-auto">
          <etrusted-widget data-etrusted-widget-id="wdg-7dad729a-c376-426c-99db-109e7e8e9615" data-sku="${escapeHtml(skus)}"></etrusted-widget>
        </div>`
      : "";

    const firstOption = product.options && product.options[0];
    const optionValues = (firstOption && firstOption.values) || [];
    const totalOptions = optionValues.length;
    const remainingOptions = totalOptions - 1;

    let variantPillsHtml = "";
    if (totalOptions > 1) {
      const mobileCountHtml = hasClothingTag
        ? ""
        : `<span class="caption text-subdued px-2 py-[3px] rounded-full bg-white whitespace-nowrap lg:hidden">${escapeHtml(translations.flavoursCountTemplate.replace("__COUNT__", totalOptions))}</span>`;
      variantPillsHtml = `
        ${mobileCountHtml}
        <div class="hidden lg:block overflow-visible w-full" data-variant-pills>
          <div class="flex items-center">
            <span class="shrink-0 mr-[5px] caption text-subdued px-2 py-[3px] rounded-full bg-bg-gray lg:bg-white whitespace-nowrap">${escapeHtml(optionValues[0])}</span>
            <span class="shrink-0 mr-[5px] caption text-subdued px-2 py-[3px] rounded-full bg-bg-gray lg:bg-white whitespace-nowrap">${escapeHtml(translations.moreVariantsTemplate.replace("__COUNT__", remainingOptions))}</span>
          </div>
        </div>`;
    }

    const priceHtml = `
      <p class="body-small lg:body font-bold ${isOnSale ? "text-discount" : ""}">${formatMoney(priceCents)}</p>
      ${isOnSale ? `<p class="body-small lg:body font-light line-through">${formatMoney(compareCents)}</p>` : ""}`;

    return `
      <article class="product-card bg-bg-gray px-2 py-1.5 rounded-2xl relative flex flex-col h-full group overflow-clip lg:hover:bg-smoky-black/10 transition-colors gap-2 lg:bg-bg-gray lg:rounded-md lg:gap-4 lg:p-[13px]">
        ${badgeHtml}
        <div class="bg-white relative aspect-[4/5] overflow-hidden rounded-lg lg:rounded-md">
          <a href="${url}" class="w-full h-full flex items-center justify-center">${imageHtml}</a>
          ${wishlistHtml}
        </div>
        <div class="product-card__content flex flex-col items-start gap-2 lg:gap-[13px] w-full flex-1">
          <div class="flex flex-col items-start gap-1 lg:gap-[5px] w-full">
            ${etrustedHtml}
            <h3 class="product-card__title body-small lg:body font-semibold line-clamp-2 lg:line-clamp-none min-h-[2lh] lg:min-h-0">
              <a href="${url}" class="after:absolute after:inset-0">${title}</a>
            </h3>
          </div>
          ${variantPillsHtml}
          <div class="product-card__price pb-1 flex gap-1.5 lg:gap-2 items-baseline flex-wrap mt-auto">${priceHtml}</div>
        </div>
      </article>`;
  }

  async function renderRecommendations() {
    if (!recommendationsEl || !recommendationsGridEl) return;

    const products = await fetchRecommendations();
    if (products.length === 0) return;

    recommendationsGridEl.innerHTML = products
      .map(buildRecommendationCardHtml)
      .join("");
    recommendationsEl.classList.remove("hidden");
    recommendationsEl.classList.add("flex");
  }

  function showEmptyState() {
    contentEl.classList.add("hidden");
    itemsEl.innerHTML = "";
    emptyEl.classList.remove("hidden");
    emptyEl.classList.add("flex");

    if (recommendationsEl) {
      recommendationsEl.classList.add("hidden");
      recommendationsEl.classList.remove("flex");
    }
    renderRecommendations();
  }

  /* ── Quantity / remove handlers ────────────────────────────── */

  function setRowBusy(row, busy) {
    const disabled = !!busy;
    row
      .querySelector("[data-drawer-qty-minus]")
      ?.toggleAttribute("disabled", disabled);
    row
      .querySelector("[data-drawer-qty-plus]")
      ?.toggleAttribute("disabled", disabled);
    row
      .querySelector("[data-drawer-qty-input]")
      ?.toggleAttribute("disabled", disabled);
    row
      .querySelector("[data-drawer-remove-item]")
      ?.toggleAttribute("disabled", disabled);
  }

  /**
   * Preserve scroll position, fully re-render the cart, and restore scroll.
   * This ensures all prices, discounts, savings, and compare-at prices
   * are always in sync with the server response.
   */
  function rerenderCart(cart) {
    const scrollContainer = itemsEl.parentElement;
    const scrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

    isRendering = true;
    renderCart(cart);
    if (scrollContainer) scrollContainer.scrollTop = scrollTop;
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    isRendering = false;
  }

  async function handleQuantityChange(row, newQuantity) {
    const input = row.querySelector("[data-drawer-qty-input]");
    if (!input) return;

    const key = row.getAttribute("data-line-item-key");
    if (!key) return;

    const quantity = Math.max(0, parseInt(newQuantity, 10) || 0);

    /* Optimistic UI: update the input immediately */
    input.value = quantity;
    setRowBusy(row, true);
    setDrawerBusy(true);

    try {
      const cart = await changeCartLine(key, quantity);
      rerenderCart(cart);
    } catch {
      /* On error, re-fetch to guarantee UI matches server state */
      try {
        const cart = await fetchCart();
        rerenderCart(cart);
      } catch {
        setRowBusy(row, false);
      }
    } finally {
      setDrawerBusy(false);
    }
  }

  /* ── Delegated event listeners ─────────────────────────────── */

  itemsEl.addEventListener("click", (e) => {
    const minusBtn = e.target.closest("[data-drawer-qty-minus]");
    const plusBtn = e.target.closest("[data-drawer-qty-plus]");
    const removeBtn = e.target.closest("[data-drawer-remove-item]");

    if (!minusBtn && !plusBtn && !removeBtn) return;

    e.preventDefault();
    const row = e.target.closest("[data-cart-drawer-line-item]");
    if (!row) return;

    const input = row.querySelector("[data-drawer-qty-input]");
    if (!input) return;

    if (minusBtn) {
      const qty = Math.max(0, parseQty(input.value)) - 1;
      handleQuantityChange(row, qty);
    } else if (plusBtn) {
      const qty = parseQty(input.value) + 1;
      handleQuantityChange(row, qty);
    } else if (removeBtn) {
      handleQuantityChange(row, 0);
    }
  });

  itemsEl.addEventListener("change", (e) => {
    const input = e.target.closest("[data-drawer-qty-input]");
    if (!input) return;

    const row = input.closest("[data-cart-drawer-line-item]");
    if (!row) return;

    const qty = parseQty(input.value);
    if (Number.isNaN(qty) || qty < 0) {
      input.value = input.getAttribute("value") || 0;
      return;
    }
    handleQuantityChange(row, qty);
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener("click", closeDrawer);
  });

  backdrop.addEventListener("click", closeDrawer);

  /* ── Collapsible summary (mobile) ────────────────────────── */

  if (summaryToggleBtn && summaryDetailsEl) {
    summaryToggleBtn.addEventListener("click", () => {
      const expanded =
        summaryToggleBtn.getAttribute("aria-expanded") === "true";
      summaryToggleBtn.setAttribute("aria-expanded", String(!expanded));
      summaryDetailsEl.classList.toggle("hidden", expanded);
      summaryDetailsEl.classList.toggle("flex", !expanded);
      if (summaryChevronEl) {
        summaryChevronEl.classList.toggle("-rotate-180", !expanded);
      }
    });
  }

  /* ── Discount code ────────────────────────────────────────── */

  const discountApplyBtn = drawer.querySelector(
    "[data-cart-drawer-discount-apply]",
  );

  function showDiscountError() {
    if (errorEl) {
      errorEl.textContent = translations.discountInvalid;
      errorEl.classList.remove("hidden");
    }
  }

  function hideDiscountError() {
    if (errorEl) errorEl.classList.add("hidden");
  }

  async function applyDiscount() {
    const code = discountInput?.value.trim();
    if (!code) return;

    hideDiscountError();
    if (discountApplyBtn) discountApplyBtn.disabled = true;
    if (discountInput) discountInput.disabled = true;
    setDrawerBusy(true);

    try {
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        method: "GET",
        redirect: "follow",
      });
      const cart = await fetchCart();

      /* Verify the code was actually accepted by Shopify */
      const codeApplied = (cart.discount_codes || []).some(
        (d) =>
          d.code &&
          d.code.toLowerCase() === code.toLowerCase() &&
          d.applicable !== false,
      );

      rerenderCart(cart);

      if (codeApplied) {
        if (discountInput) discountInput.value = "";
      } else {
        showDiscountError();
      }
    } catch {
      showDiscountError();
    } finally {
      setDrawerBusy(false);
      if (discountApplyBtn) discountApplyBtn.disabled = false;
      if (discountInput) discountInput.disabled = false;
    }
  }

  if (discountApplyBtn) {
    discountApplyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      applyDiscount();
    });
  }

  if (discountInput) {
    discountInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        applyDiscount();
      }
    });
    discountInput.addEventListener("input", hideDiscountError);
  }

  footerEl.addEventListener("click", async (e) => {
    const removeBtn = e.target.closest("[data-drawer-discount-remove]");
    if (!removeBtn) return;

    e.preventDefault();
    removeBtn.disabled = true;
    setDrawerBusy(true);

    try {
      const cart = await clearCartDiscountCodes();
      rerenderCart(cart);
    } catch {
      /* Re-sync UI even on failure */
      try {
        const cart = await fetchCart();
        rerenderCart(cart);
      } catch {
        removeBtn.disabled = false;
      }
    } finally {
      setDrawerBusy(false);
    }
  });

  /* ── Header cart icon → open drawer instead of navigating ──── */

  document.querySelectorAll("[data-header-cart-link]").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("cart:open"));
    });
  });

  /* ── cart:open event ───────────────────────────────────────── */

  document.addEventListener("cart:open", async () => {
    loadingEl.classList.remove("hidden");
    contentEl.classList.add("hidden");
    emptyEl.classList.add("hidden");
    emptyEl.classList.remove("flex");

    openDrawer();

    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch {
      loadingEl.classList.add("hidden");
      showEmptyState();
    }
  });

  /* ── Re-render when external scripts modify the cart ──────── */

  document.addEventListener("cart:refresh", async () => {
    if (!isOpen || isRendering) return;
    setDrawerBusy(true);
    try {
      const cart = await fetchCart();
      rerenderCart(cart);
    } catch {
      /* Silent — external refresh is best-effort */
    } finally {
      setDrawerBusy(false);
    }
  });

  /* ── Swipe-to-dismiss (mobile bottom sheet) ─────────────── */

  const dragHandleEl = drawer.querySelector("[data-cart-drawer-drag-handle]");
  if (dragHandleEl) {
    let dragStartY = 0;
    let dragDeltaY = 0;
    let isDraggingSheet = false;

    dragHandleEl.addEventListener(
      "touchstart",
      (e) => {
        if (window.matchMedia("(min-width: 1024px)").matches) return;
        isDraggingSheet = true;
        dragStartY = e.touches[0].clientY;
        dragDeltaY = 0;
        drawer.style.transition = "none";
      },
      { passive: true },
    );

    dragHandleEl.addEventListener(
      "touchmove",
      (e) => {
        if (!isDraggingSheet) return;
        dragDeltaY = e.touches[0].clientY - dragStartY;
        if (dragDeltaY > 0) {
          drawer.style.transform = `translateY(${dragDeltaY}px)`;
        }
      },
      { passive: true },
    );

    dragHandleEl.addEventListener("touchend", () => {
      if (!isDraggingSheet) return;
      isDraggingSheet = false;
      drawer.style.transition = "";
      drawer.style.transform = "";
      if (dragDeltaY > 80) {
        closeDrawer();
      }
      dragDeltaY = 0;
    });
  }
})();
